export const talksData = [
  {
    title: 'Guardrails in Agentic AI',
    type: 'Meetup',
    event: 'Arize AX Google Cloud 2025 - London',
    date: 'April 2025',
    description: 'An exploration of unintended consequences in building production-ready agentic applications and how to safeguard against them.',
    images: [
      '/images/talks/arize/arize-1.jpg',
      '/images/talks/arize/arize-3.jpg',
      '/images/talks/arize/arize-4.jpg',
    ],
    linkedinPosts: [
      'https://www.linkedin.com/feed/update/urn:li:activity:7310766186655293442/',
    ],
    topics: [
      'Agentic workflows',
      'Challenges',
      'Guardrails - types and implementations',
    ],
    video: 'https://youtu.be/YKMJgWd09XM?t=4576', 
    slides: 'https://docs.google.com/presentation/d/12LQmbO3zuCaa3dcarDWXyBlGFZ0O5-BBpNUK_gKGLIo/edit?pli=1&slide=id.g33df1cc0264_0_0#slide=id.g33df1cc0264_0_0', // Add slides URL when available
  },
  {
    title: 'Boost your AI performance',
    type: 'Webinar',
    event: 'AWS Webinar Series',
    date: 'November 2024',
    images: [
      '/images/talks/webinar/title.png',
      '/images/talks/webinar/fine-tuning.png',
    ],
    description: 'Learn the differences between RAG and Fine tuning and understand when to use each.',
    video: 'https://drive.google.com/file/d/1KrAqugBJ7lnDjW6w5QL0CvBLuPXWCnYm/view', 
  },
  {
    title: 'Challenges in Agentic Applications',
    type: 'Meetup',
    event: 'AI Agent Week - London',
    date: 'April 2025',
    description: 'An exploration of unintended consequences in building production-ready agentic applications and how to safeguard against them.',
    images: [
      '/images/talks/arize/crew-1.jpg',
    ],
    linkedinPosts: [
      'https://www.linkedin.com/posts/olaonipekunolaitan_aiagentweek-thankyou-ai-activity-7313501157660741633-tk0S/',
      'https://luma.com/j3xr1ze1?coupon=WEAVIATE',
    ],
    topics: [
      'Agentic workflows',
      'Challenges',
      'Guardrails - types and implementations',
    ],
    slides: 'https://docs.google.com/presentation/d/12LQmbO3zuCaa3dcarDWXyBlGFZ0O5-BBpNUK_gKGLIo/edit?pli=1&slide=id.g33df1cc0264_0_0#slide=id.g33df1cc0264_0_0', // Add slides URL when available
  },
  // {
  //   title: 'Introduction to Semantic Search and Embeddings',
  //   type: 'video',
  //   event: 'Developer Advocate Series',
  //   date: '2024',
  //   description: 'A comprehensive introduction to semantic search, explaining how embeddings work and how to implement vector search in your applications.',
  //   topics: [
  //     'Understanding embeddings and vector representations',
  //     'Semantic vs keyword search',
  //     'Practical implementation with Weaviate',
  //     'Use cases and applications',
  //   ],
  //   video: '', // Add your video URL
  //   article: 'https://weaviate.io/blog',
  // },
  // {
  //   title: 'Enterprise AI Workflows: From Prototype to Production',
  //   type: 'workshop',
  //   event: 'DevRel Workshop Series',
  //   date: '2024',
  //   description: 'Hands-on workshop covering the journey from AI prototypes to production systems, including evaluation, monitoring, and scaling strategies.',
  //   topics: [
  //     'Prototyping with LangChain and Weaviate',
  //     'Evaluation frameworks for AI systems',
  //     'Implementing guardrails and safety measures',
  //     'Scaling and optimization techniques',
  //   ],
  //   slides: '', // Add slides URL
  //   article: 'https://weaviate.io/blog/enterprise-workflow-langchain-weaviate',
  // },
  // {
  //   title: 'Model Evaluation and Monitoring Best Practices',
  //   type: 'conference',
  //   event: 'MLOps Summit',
  //   date: '2024',
  //   description: 'Discussing strategies for evaluating and monitoring AI models in production, with focus on RAG systems and LLM applications.',
  //   topics: [
  //     'Key metrics for RAG evaluation',
  //     'Continuous monitoring strategies',
  //     'A/B testing for AI systems',
  //     'Handling model drift and degradation',
  //   ],
  //   slides: '', // Add slides URL
  //   article: 'https://weaviate.io/blog/when-good-models-go-bad',
  // },
];

// To add a new talk/presentation, add an object with this structure:
/*
{
  title: 'Your Talk Title',
  type: 'conference' | 'workshop' | 'video' | 'webinar' | 'meetup',
  event: 'Event or Series Name',
  date: 'Month Year',
  description: 'A detailed description of what the talk covers (2-3 sentences)',
  topics: [
    'Key topic 1',
    'Key topic 2',
    'Key topic 3',
    'Key topic 4',
  ],
  video: 'https://youtube.com/watch?v=...', // Optional - YouTube or video URL
  slides: 'https://slides.com/...', // Optional - Slides URL (Google Slides, SlideShare, etc.)
  article: 'https://related-article-url', // Optional - Related blog post
}
*/

